import { isPlatform } from '@ionic/react';
import { EnumType } from 'json-to-graphql-query';
import { UserDetails } from '../../../models/userProfile/userProfile.modal';
import { clear, GPSWrapper, isAdminRoleAvailble } from '../../../utils/common';
import { ToastMessage } from '../../../utils/ToastMessage';
import i18n from "../../../../i18n";
export const PATH = 'manage/ManageUser';

export const userProfileModel = new UserDetails();

export const backToPage = (props: any) => {
  if (props && props.isAssignDriver)
    props.history.push(`${props.module}`);
  else
    props.history.push(isPlatform('desktop') ? `/app/manage` : `/app/${PATH}`);
};

export const handleSubmit = (props: any) => (
  payload: any,
  restData: Function
) => {
  const query = userProfileModel.addUser(payload);
  const callback = (success = false) => {
    if (success) {
      restData();
      ToastMessage.show(i18n.t('MANAGE_USER_SUCCESS_MESSAGE'));
      backToPage(props);
      return true;
    }
    ToastMessage.show(i18n.t('OOPS_MESSAGE'));
  };
  props.addUserAction({
    query,
    callback,
    isCarrierAssign: !!props.isAssignDriver
  });
};

export const handleTransfer = (props: any) => (
  payload: any,
  restData: Function,
  isCarrierSame = false
) => {
  const { name, params } = payload;
  props.resetValidateUser();
  if (isCarrierSame) {
    restData();
    ToastMessage.show(i18n.t('MANAGE_USER_TRANSFER_EXIST'));
    backToPage(props);
    return true;
  }
  const query = userProfileModel.transferMember(params);
  const callback = (success = false) => {
    restData();
    if (success) {
      ToastMessage.open({
        message:i18n.t('MANAGE_USER_TRANSFER_MESSAGE').replace('NAME', name),
        btnTitle: i18n.t('Ok_TEXT'),
        showUndo: true,
        callback: () => null
      });
    } else {
      ToastMessage.show(i18n.t('OOPS_MESSAGE'));
    }
    backToPage(props);
  };
  props.transferUserAction({ query, callback });
};

async function azureLogout(props: any) {
  if (isPlatform('capacitor')) {
    GPSWrapper.details.stopGPS();
  }
  await clear();
  await props.authService.logout();
  await props.logout();
}

export const handleDelink = (props: any, isProfile = false) => (
  payload: any
) => {
  const {
    userDetails: { userId }
  } = payload;
  const query = userProfileModel.updateMember(payload);
  const isProfile = isSelf(props.userDetails, props.selectedUser);
  const callback = async (success = false) => {
    if (success) {
      ToastMessage.show(i18n.t('MANAGE_USER_REMOVE_SUCCESS_TEXT'));
      if (isProfile) {
        await azureLogout(props);
        return true;
      }
      props.history.push(
        `${isPlatform('desktop') ? '/app/manage' : `/app/${PATH}`}`
      );
      return true;
    }
    ToastMessage.show(i18n.t('MANAGE_USER_REMOVE_FAILURE_TEXT'));
  };
  props.delinkUserAction({ query, userId, callback });
};

export const handleUpdateSubmit = (
  props: any,
  isManageProfile = false,
  isSelfDesktop = false,
  isSelfMobile = false
) => (payload: any, restData: Function) => {
  if(isSelfMobile){
    const userUpdatedRole = props.userDetails && props.userDetails.memberDetailsResponse &&
    props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.userApplicationDetails &&
      props.userDetails.memberDetailsResponse.member.userApplicationDetails
        .reduce((current: any, item: any) => {
          return [...current, ...item.roles];
        }, [])
        .map((role: any) => role.roleName);
    let roleDetails: any = [];
    userUpdatedRole.map((role: any) => roleDetails.push(new EnumType(role)))
    if (!isAdminRoleAvailble()) { payload.userDetails = { ...payload.userDetails, roles: roleDetails } }
  }
  const query = userProfileModel.updateMember(payload);
  const callback = (success = false, userDetails = null) => {
    if (success) {
      restData(userDetails);
      ToastMessage.show(i18n.t('MANAGE_USER_UPDATE_SUCCESS'));
      if (!isSelfDesktop) {
        if (isManageProfile) {
          props.history.push(`/app/${PATH}/Profile`);
        } else {
          props.history.push(`/app/manage/ProfileDetails`);
        }
      }
      return true;
    }
    ToastMessage.show(i18n.t('OOPS_MESSAGE'));
  };
  props.updateUserAction({ query, isProfile: !isManageProfile, callback });
};

export const isSelf = (userDetails: any, selectedUser: any) => {
  if (selectedUser && userDetails) {
      return userDetails?.memberDetailsResponse?.member?.upn === selectedUser?.upn
  }
  return false;
}